import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import React, {useContext} from 'react'
import {IoHome} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import useTranslate from "../../../../modules/local/useTranslate";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";

const ActionButtons = ({item}) => (
    <div className="hidden md:flex flex-row space-x-1">
        <Link
            to={getLinkToDetail(item)}
            className="w-10 h-10 rounded-full flex flex-center background-100 hover:bg-primary-100 text-color-500 hover:text-primary">
            <IoHome className="Icon"/>
        </Link>
    </div>
)

const CalendarAvatar = ({time}) => {
    const {isSm} = useContext(LayoutContext)
    const dt = dayjs(time)
    const validDt = dt.isValid() ? dt : dayjs()

    const LeftPattern = () => (
        <div style={{
            position: 'absolute',
            width: '8px',
            height: isSm ? 11 : 14,
            top: '-5px',
            left: isSm ? 16 : 18,
            borderTopLeftRadius: '3px',
            borderTopRightRadius: '3px',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
            backgroundColor: 'var(--background)',
        }}/>
    )

    const RightPattern = () => (
        <div style={{
            position: 'absolute',
            width: '8px',
            height: isSm ? 11 : 14,
            top: '-5px',
            right: isSm ? 16 : 18,
            borderTopLeftRadius: '3px',
            borderTopRightRadius: '3px',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
            backgroundColor: 'var(--background)',
        }}/>
    )

    var month = dt.format('MMM')
    var day = dt.format('DD')

    return (
        <div
            style={{
                zIndex: 1,
                width: isSm ? 65 : 80,
                height: isSm ? 65 : 80,
                boxShadow: 'rgba(0, 0, 0, 0.15) 0px 6px 6px 0px',
                borderRadius: '0.65rem',
            }}
            className="flex flex-col flex-center gap-2 bg-secondary text-white p-2 relative">
            <LeftPattern/>
            <RightPattern/>
            <div className="flex flex-center font-bold text-2xs md:text-sm uppercase truncate">
                {month}
            </div>
            <div
                style={{width: '90%', lineHeight: 1.4}}
                className="flex flex-center rounded-lg font-bold text-xs md:text-xl text-secondary bg-white tracking-wide">
                {day}
            </div>
        </div>
    )
}

const EventSettingHeader = ({event}) => {

    const t = useTranslate()
    const item = event || {}

    if (_.isEmpty(item)) return null

    return (
        <div className="flex py-3 w-full container mx-auto flex-col">
            <div className="flex items-center gap-3">
                <CalendarAvatar time={_.get(event, 'time_open')}/>
                <div className="flex flex-col gap-0 md:gap-1 flex-1">
                    <Link
                        className="text-base md:text-2xl font-bold text-color-000 hover:text-primary no-underline flex-1"
                        title={item.title}
                        to={getLinkToDetail(item)}>
                        {getTitle(item)}
                    </Link>
                    <div
                        className="flex flex-col md:flex-row gap-x-2 uppercase text-xs md:text-sm text-color-100 opacity-75 font-semibold tracking-wide">
                        <span>
                            <span className="font-normal capitalize italic opacity-50 mr-2">{t('from')}</span>
                            {formatDate(_.get(event, 'time_open'), 'hh:mm a - Do MMMM, YYYY')}
                        </span>
                        {_.get(event, 'time_close') && (
                            <span>
                                <span className="font-normal lowercase italic opacity-50 mr-2">{t('to')}</span>
                                {formatDate(_.get(event, 'time_close'), 'hh:mm a - Do MMMM, YYYY')}
                            </span>
                        )}
                    </div>
                </div>
                <ActionButtons {...{item}} />
            </div>
        </div>
    )
}

export default EventSettingHeader
